export default __webpack_public_path__ + "static/media/cross.e3b24d58.svg";